export const isEmail = (email: string) => {
    if (!email) return;
    const EmailRegex = new RegExp(/^[\w\-.+]+@([\w-]+\.)+[\w-]{2,}$/);
    if (!EmailRegex.test(email)) {
        return 'Must be a valid email';
    }
};
